import MiniMasonry from "./components/Masonry";
import Widget from "./components/Widget";
import RangeSlider from "./components/RangeSlider";
import YouTubePlayer from "./components/YoutubePlayer";

function loadYouTubeIframePlayerApi() {
    const tag = document.createElement('script');
    const firstScriptTag = document.getElementsByTagName('script')[0];

    tag.src = 'https://www.youtube.com/iframe_api';
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

window.onYouTubeIframeAPIReady = function () {
    const youTubeVideos = document.querySelectorAll('[data-yt-data]');
    if (youTubeVideos.length) {
        youTubeVideos.forEach((el) => {
            new YouTubePlayer(el);
        });
    }
};

window.addEventListener('DOMContentLoaded', (e) => {
    if (document.querySelectorAll('[data-yt-data]').length) {
        loadYouTubeIframePlayerApi();
    }

    const rangeSliders = document.querySelectorAll('[data-range-slider]');
    if (rangeSliders.length) {
        rangeSliders.forEach((slider) => {
            new RangeSlider(slider);
        });
    }

    if (document.querySelectorAll('[data-ketelomlaag-widget]').length) {
        new Widget();
    }

    if (document.querySelectorAll('[data-masonry-item]').length) {
        const masonry = new MiniMasonry({
            container: '[data-masonry-collection]',
            gutterX: 40,
            gutterY: 20,
            ultimateGutter: 20
        });
    }

    const printBtns = document.querySelectorAll('[data-print]');
    if (printBtns.length) {
        printBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
                window.print();
            });
        })
    }

});